import { PatientManagement } from "components/features/patient";
import React from "react";

const PatientManagementPage: React.FC = () => {
  return <PatientManagement />;
};

export default PatientManagementPage;
